import { render, staticRenderFns } from "./NotFoundPlan.vue?vue&type=template&id=13f1228e&scoped=true&"
import script from "./NotFoundPlan.vue?vue&type=script&lang=js&"
export * from "./NotFoundPlan.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundPlan.vue?vue&type=style&index=0&id=13f1228e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f1228e",
  null
  
)

export default component.exports